import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import 'dayjs/locale/zh-cn';

import AppRoutes from './AppRoutes';
import {AuthChecker, AuthStoreProvider} from '@/context/auth';
import {PUBLIC_URL} from '@/env';

const App = () => (
    <ConfigProvider locale={zhCN}>
        <BrowserRouter basename={PUBLIC_URL}>
            <AuthStoreProvider>
                <AuthChecker />
                <AppRoutes />
            </AuthStoreProvider>
        </BrowserRouter>
    </ConfigProvider>
);

export default App;
